import styled from "styled-components";
import {
  Space,
  Input,
  Badge,
  Typography,
  Avatar,
  Tooltip,
  Breadcrumb,
  Button,
  Menu,
  Divider,
  Modal,
  Flex,
  Form,
  Layout,
} from "antd";
import { ReactComponent as BackButtonIcon } from "../../assets/icons/BackButton.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../assets/icons/Sort.svg";

const { Text } = Typography;

export const StyledAvatarGroup = styled(Avatar.Group).attrs({
  max: {
    style: {
      backgroundColor: "white",
      color: "#7F56D9",
      fontSize: "12px",
      fontWeight: 500,
    },
  },
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: -0.15rem;
  direction: ltr;
  width: 100%;
  justify-content: flex-end;
`;

export const StyledAvatar = styled(Avatar).attrs({
  style: { color: "white", fontSize: "12px", fontWeight: 500 },
})`
  height: 24px;
  width: 24px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background-color: #5f5df0;
`;

export const StyledTotalNumAvatar = styled(Avatar).attrs({
  style: { color: "#7F56D9", fontSize: "12px", fontWeight: 500 },
})`
  height: 24px;
  width: 24px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background-color: rgb(255, 255, 255);
`;

export const StyledTooltip = styled(Tooltip)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledBackButtonIcon = styled(BackButtonIcon)`
  width: 24px;
  height: 24px;
`;

export const BackButton = styled(Button)`
  width: 2rem;
  height: 2rem;
  border: 0;
  outline: none;
  box-shadow: none;
  background-color: transparent;

  &:hover {
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  font-family: "Alef", sans-serif;
  height: 100%;
  font-size: 18px;
  cursor: pointer;
  li: last-child {
    font-weight: bold;
  }
`;

export const StyledSpace = styled(Space)`
  display: flex;
  align-items: center;
`;

export const StyledHorizontalSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "middle",
})`
  display: flex;
`;

export const StyledVerticalSpace = styled(Space).attrs({
  direction: "vertical",
  size: "middle",
})`
  display: flex;
`;

export const StyledMenu = styled(Menu)`
  .ant-menu-item {
    span {
      font-size: 14px;
      color: #808080;
    }
  }
  .ant-menu-item-selected {
    span {
      font-weight: bold;
      color: #313131;
    }
  }
`;

export const StyledHorizontalDivider = styled(Divider).attrs({
  type: "horizontal",
})`
  margin: 20px 0;
`;

export const StyledColoredHeadline = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: #5f5df0;
`;

export const StyledPlaceholder = styled(Text)`
  color: rgb(191 191 191);
  font-size: 14px;
  font-weight: 400;
  padding-right: 8px;
  padding-top: 10px;
`;

export const StyledEditButton = styled(Button).attrs({
  type: "text",
})`
  background-color: #5f5df0;
  width: 51px;
  height: 32px;
  padding: 4px 8px 4px 8px;
  gap: 8px;
  border-radius: 6px 6px 6px 6px;
  opacity: 0px;
  color: white;
`;

export const StyledSearchBar = styled(Input.Search)`
  direction: rtl;
  width: 18.75rem;
  border-radius: 6px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;

  .ant-btn {
    border-right: none;
  }
`;

export const StyledFilterButton = styled(Button)`
  width: 74px;
  height: 32px;
  border: 1px solid #dde2e4;
  outline: none;
  box-shadow: none;
  direction: ltr !important;
  font-size: 14px;
  padding: 0;
  display: "flex";
  gap: 10px;
  span {
    display: flex;
    align-items: center;
  }
`;

export const StyledFiltersBar = styled(Flex).attrs({
  justify: "end",
  gap: 10,
})`
  margin-top: 20px;
`;

export const StyledSortIcon = styled(SortIcon)`
  width: 24px;
  height: 24px;
`;

export const StyledFilterIcon = styled(FilterIcon)`
  width: 24px;
  height: 24px;
`;

export const StyledBadge = styled(Badge)`
  .ant-badge-count {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const StyledDeleteModal = styled(Modal)`
  direction: rtl;
  .ant-modal-footer {
    display: flex;
    gap: 10px;
    flex-direction: row-reverse;
    margin-top: 40px;
  }
  .ant-btn {
    width: 100%;
    height: 40px;
    margin: 0;
  }

  .ant-btn-primary {
    background-color: rgb(220, 54, 54);
  }
  .ant-btn-primary:hover {
    background-color: rgb(237, 104, 104) !important;
  }
`;

export const RelativeFlex = styled(Flex)`
  position: relative;
`;

export const AbsoluteButton75 = styled(Button).attrs({
  type: "primary",
  shape: "round",
  htmlType: "submit",
})`
  min-width: 75px;
  position: absolute;
  left: 10px;
  top: -75px;
`;

export const AbsoluteButton55 = styled(Button).attrs({
  type: "primary",
  shape: "round",
  htmlType: "submit",
})`
  min-width: 75px;
  position: absolute;
  left: 10px;
  top: -55px;
`;

export const AbsoluteButton35 = styled(Button).attrs({
  type: "primary",
  shape: "round",
  htmlType: "submit",
})`
  min-width: 75px;
  position: absolute;
  left: 10px;
  top: -35px;
`;

export const NotFoundText = styled(Typography.Title).attrs({
  level: 4,
})`
  color: #313131;
  margin-top: 100px;
  text-align: center;
`;

export const StyledColumnWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "large",
})`
  width: 35%;
  max-width: 35%;

  @media (min-width: 1024px) {
    width: 40%;
    max-width: 40%;
  }
`;

export const StyledForm = styled(Form)`
  padding-bottom: 20px;
`;

export const StyledLayout = styled(Layout)`
  background-color: transparent;
  padding-top: 1rem;
  display: flex;
  flex-direction: row;
  gap: 3rem;
  max-height: calc(100vh - 182px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5f5df0;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const StyledLongLayout = styled(StyledLayout)`
  max-height: calc(100vh - 212px);
`;

export const StatusTag = styled(Flex)<{ active: boolean }>`
  font-size: 12px;
  height: 28px;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  width: fit-content;
  padding: 0 15px;
  background-color: ${(props) => (props.active ? "#ecfdf3" : "#f8f8f8")};
  color: ${(props) => (props.active ? "#027A48" : "#808080")};
`;

export const ErrorText = styled(Text)`
  color: red;
`;

export const FullWidthFlex = styled(Flex)`
  width: 100%;
`;

export const StyledOutletLayout = styled(Layout)`
  background-color: transparent;
`;

export const StyledVerticalDivider = styled(Divider).attrs({
  type: "vertical",
})`
  height: 100%;
`;

export const StyledModal = styled(Modal)`
  direction: rtl;
  .ant-modal-footer {
    display: flex;
    gap: 10px;
    flex-direction: row-reverse;
    margin-top: 20px;
  }
  .ant-btn {
    width: 100%;
    height: 40px;
    margin: 0;
  }

  .ant-btn-primary {
    background-color: #5f5df0;
  }
  .ant-btn-primary:hover {
    background-color: #94a5f2 !important;
  }
`;
